































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ReplayLog } from '@/class/game'
import ReplayRoleComingOutViewer from './ReplayRoleComingOutViewer.vue'
import ReplaySelfProclaimNoticeViewer from './ReplaySelfProclaimNoticeViewer.vue'
import ReplayProclaimPolice from './ReplayProclaimPolice.vue'
import ReplayProclaimInvestigator from './ReplayProclaimInvestigator.vue'
import ReplayNightViewer from './ReplayNightViewer.vue'
import ReplayVoteViewer from './ReplayVoteViewer.vue'
import ReplayNightVoteViewer from './ReplayNightVoteViewer.vue'
import ReplayTakeOther from './ReplayTakeOther.vue'
import ReplayResultViewer from './ReplayResultViewer.vue'
import DayCount from './DayCount.vue'

@Component({
  components: {
    DayCount,
    ReplayRoleComingOutViewer,
    ReplaySelfProclaimNoticeViewer,
    ReplayProclaimPolice,
    ReplayProclaimInvestigator,
    ReplayNightViewer,
    ReplayVoteViewer,
    ReplayNightVoteViewer,
    ReplayTakeOther,
    ReplayResultViewer,
  }
})
export default class ReplayViewer extends Vue {
  @Prop() gameLog!: ReplayLog;

  get isRoleComingOut() {
    return this.gameLog.roleComingOut
  }

  get isSelfProclaimNotice() {
    return this.gameLog.selfProclaimNotice
  }

  get isProclaimPolice() {
    return this.gameLog.policeResult
  }

  get isProclaimInvestigator() {
    return this.gameLog.investigatorResult
  }

  get isAction() {
    return this.gameLog.nightAction || this.gameLog.takeOtherAction
  }

  get isNightAction() {
    return this.gameLog.action
  }

  get takeOtherAction() {
    return this.gameLog.takeOtherAction
  }

  get nightVoteResult() {
    return this.gameLog.nightVoteResult
  }

  get voteResult() {
    return this.gameLog.voteResult
  }

  get gameResult() {
    return this.gameLog.gameResult
  }
}
